import React, { useState, useEffect } from 'react';
import {
	Button,
	Grid,
	MenuItem,
	Paper,
	Select,
	Typography,
	FormControl,
	InputLabel,
	TextField,
} from '@mui/material';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	apiUpdateUserClient,
	apiDeleteUserClient,
	IUserClient,
	IUserBackEnd,
	IClientBackend,
} from '../../../services/apiService';
import ConfirmDeleteDialog from '../ConfirmDeleteDialog';

interface UpdateUserClientProps {
	relations: IUserClient[];
	users: IUserBackEnd[];
	clients: IClientBackend[];
}

const UpdateUserClient: React.FC<UpdateUserClientProps> = ({
	relations,
	users,
	clients,
}) => {
	const [updatedRelations, setUpdatedRelations] = useState<IUserClient[]>([]);
	const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
	const [selectedId, setSelectedId] = useState<number | null>(null);

	useEffect(() => {
		const sorted = [...relations].sort((a, b) =>
			a.username.localeCompare(b.username)
		);
		setUpdatedRelations(sorted);
	}, [relations]);

	const handleUpdate = async (rel: IUserClient) => {
		try {
			await apiUpdateUserClient(rel.id, {
				user_id: rel.user_id,
				client_id: rel.client_id,
			});
			toast.success('Relação atualizada com sucesso');
		} catch (error) {
			toast.error('Erro ao atualizar relação');
		}
	};

	const handleDelete = async (id: number) => {
		try {
			await apiDeleteUserClient(id);
			setUpdatedRelations(prev => prev.filter(r => r.id !== id));
			toast.success('Relação deletada com sucesso');
		} catch (error) {
			toast.error('Erro ao deletar relação');
		}
	};

	return (
		<Grid item xs={12}>
			<Paper elevation={5} style={{ padding: 20 }}>
				<Typography
					variant="h6"
					component="h3"
					style={{ marginBottom: '20px' }}
				>
					Relações Usuário-Cliente
				</Typography>
				{updatedRelations.map(rel => (
					<Grid
						container
						spacing={2}
						alignItems="center"
						key={rel.id}
						style={{ marginBottom: 20 }}
					>
						<Grid item xs={3}>
							<TextField
								fullWidth
								label="Usuário"
								value={rel.username}
								InputProps={{ readOnly: true }}
							/>
						</Grid>
						<Grid item xs={3}>
							<FormControl fullWidth variant="outlined">
								<InputLabel id={`client-select-label-${rel.id}`}>
									Cliente
								</InputLabel>
								<Select
									labelId={`client-select-label-${rel.id}`}
									value={rel.client_id}
									onChange={e =>
										setUpdatedRelations(prev =>
											prev.map(r =>
												r.id === rel.id
													? { ...r, client_id: Number(e.target.value) }
													: r
											)
										)
									}
									label="Cliente"
								>
									{clients
										.sort((a, b) => a.client_name.localeCompare(b.client_name))
										.map(client => (
											<MenuItem key={client.id} value={client.id}>
												{client.client_name}
											</MenuItem>
										))}
								</Select>
							</FormControl>
						</Grid>
						<Grid item xs={2}>
							<Button
								variant="contained"
								color="primary"
								onClick={() => handleUpdate(rel)}
							>
								Atualizar
							</Button>
							<Button
								variant="contained"
								sx={{
									backgroundColor: 'red',
									'&:hover': { backgroundColor: 'darkred' },
									color: 'white',
									marginLeft: 2,
								}}
								onClick={() => {
									setSelectedId(rel.id);
									setIsDeleteDialogOpen(true);
								}}
							>
								Deletar
							</Button>
						</Grid>
					</Grid>
				))}
			</Paper>
			<ConfirmDeleteDialog
				open={isDeleteDialogOpen}
				onConfirm={() => {
					if (selectedId !== null) handleDelete(selectedId);
					setIsDeleteDialogOpen(false);
					setSelectedId(null);
				}}
				onCancel={() => {
					setIsDeleteDialogOpen(false);
					setSelectedId(null);
				}}
			/>
		</Grid>
	);
};

export default UpdateUserClient;
